<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select
          v-if="theUserProject == 0"
          v-model="theProjectId"
          @change="theProjectAllChange"
          size="small"
          clearable
          placeholder="请选择项目"
        >
        <el-option
            v-for="item in getProjectList_data.data||[]"
            :key="item.projectId"
            :label="item.projectName"
            :value="item.projectId">
        </el-option>
         </el-select>
        <el-select v-model='theRrType' clearable @change="theRrTypeChange" size="small" placeholder="选择模块">
            <el-option
                v-for="item in theRrTypeAll"
                :key="item.id"
                :label="item.name"
                :value="item.id" >
            </el-option>
        </el-select>
        <el-select v-model='theRtId' clearable @change="theRtIdChange" size="small" placeholder="选择举报类型">
            <el-option
                v-for="item in getReportTypeList_data.data||[]"
                :key="item.rtId"
                :label="item.rtName"
                :value="item.rtId" >
            </el-option>
        </el-select>
        <el-input
          v-model="getReportRecordList_data.rrContext"
          placeholder="请输入举报内容"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-button
          v-click.getReportRecordList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getReportRecordList'
      api='getReportRecordList'
      updateapi='updateReportRecord'
      :height="H-165" >
      <icol slot='rrImage' :showtooltip='false' img='rrImage' />
    </mytable>

  </div>
</template>

<script>
export default {
  data() {
    return {
      theProjectId: "",
      vtId: null,
      theRtId:"",
      theRrType:"",
      theRrTypeAll:[
        {id:1,name:"帖子"},
        {id:2,name:"群聊"},
        {id:3,name:"用户"},
      ],

      tableColums_getReportRecordList: {
        $selection: false,

        rtName: '举报类型名称',
        rrContext: '举报内容',
        rrImage: '图片',
        rrType: ['类型',,'@v-if: 1:问答圈#success, 2:群组#success, 3:用户#success, 4:其他#danger'],
        rrStatus: ['状态',,'@v-if: 1:未读#danger, 2:已读#success'],

        $operation: [
          '操作', 200,
          this.updateReportRecordStatus && `@text: 标记已读#success
           @click: _confirm('确定要标记已读该举报记录吗?')
                   .trigger('updateReportRecordStatus',{rrId:$row.rrId})
                   .trigger('getReportRecordList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    theProjectAllChange(e){
      this.theProjectId = e
      this.getReportRecordList({projectId:e});
    },
    theRrTypeChange(e){
      this.theRrType=e;
      this.getReportRecordList({rrType:this.theRrType,rtId:this.theRtId,});
    },
    theRtIdChange(e){
      this.theRtId=e;
      this.getReportRecordList({rrType:this.theRrType,rtId:this.theRtId},);
    },
  },

  created() {
 
    this.getReportTypeList();
    this.getProjectList({pageSize:0});
    this.theUserProject = A.local("$projectId");
    if (this.theUserProject != 0) {
      this.theProjectId = this.theUserProject;
    }
    this.getReportRecordList({projectId:this.theProjectId});
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/report/ReportRecordManage.vue